var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props),
    React.createElement(
      "title",
      null,
      "Max"
    ),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M17.83 1.12v1.51a1 1 0 0 1-1 1H3.17a1 1 0 0 1-1-1V1.12a1 1 0 0 1 1-1h13.66a1 1 0 0 1 1 1zM10.7 5.56a1 1 0 0 0-1.52 0L4 11.57a1 1 0 0 0 .75 1.65h3.44V19a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-5.78h3.41a1 1 0 0 0 .76-1.65z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Max.svg